import {Component, Input, OnInit} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.scss'],
    imports: [
        NgClass
    ]
})
export class PreloaderComponent implements OnInit {
  @Input() Color = false;

  constructor() { }

  ngOnInit(): void {
  }

}
